import { makeAutoObservable, runInAction } from "mobx";
import { Prompt } from "../models/prompt";
import axios, { AxiosResponse } from "axios";
import { store } from "./store";
import { AdminInput } from "../models/adminInput";
import { NewPrompt } from "../models/newPrompt";
import { PaginatedResult, Pagination, PagingParams } from "../models/pagination";

export default class AdminStore {
    prompts: Prompt[] = [];
    adminPrompts: Prompt[] = [];
    regPrompts: Prompt[] = [];
    adminInputs: AdminInput[] = [];
    pagination: Pagination | null = null;
    pagingParams = new PagingParams();

    promptUrl: string = process.env.REACT_APP_API_URL + 'admin/allPrompts';
    adminPromptUrl: string = process.env.REACT_APP_API_URL + 'admin/adminPrompts';
    inputUrl: string = process.env.REACT_APP_API_URL + 'admin/allInputs';
    addPromptUrl: string = process.env.REACT_APP_API_URL + 'admin/addPrompt';
    deletePromptUrl: string = process.env.REACT_APP_API_URL + 'admin/deletePrompt'
    deleteAdminPromptUrl: string = process.env.REACT_APP_API_URL + 'admin/deleteAdminPrompt'
    regPromptUrl: string = process.env.REACT_APP_API_URL + 'input/getPrompts';

    constructor() {
        makeAutoObservable(this)
    }

    setPagingParams = (pagingParams: PagingParams) => {
        this.pagingParams = pagingParams;
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('pageNumber', this.pagingParams.pageNumber.toString());
        params.append('pageSize', this.pagingParams.pageSize.toString());

        return params;
    }

    getPrompts = async () => {
        try {

            const response = await axios.get(this.regPromptUrl);

            runInAction(() => {
                this.prompts = [];
                const arr = Array.from(response.data.data) as Prompt[];
                arr.forEach(p => {
                    var t = {} as Prompt;
                    t.id = p.id;
                    t.isAdmin = p.isAdmin;
                    t.isVisible = p.isVisible;
                    t.promptText = p.promptText;
                    this.regPrompts.push(t);
                });
            })

        } catch (error) {
            console.log(error);
        }
    }

    getAdminPrompts = async () => {
        try {
            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            const response = await axios.get(this.adminPromptUrl);

            runInAction(() => {
                this.adminPrompts = [];
                const arr = Array.from(response.data.data) as Prompt[];
                arr.forEach(p => {
                    var t = {} as Prompt;
                    t.id = p.id;
                    t.isVisible = p.isVisible;
                    t.promptText = p.promptText;
                    this.adminPrompts.push(t);
                });

            })

        } catch (error) {
            console.log(error);
        }
    }

    getAllPrompts = async () => {
        try {
            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            axios.interceptors.response.use(async response => {

                const pag = response.headers['pagination'];

                this.setPagination(JSON.parse(pag!.toString()));
                return response;
            })
            const params = this.axiosParams;

            const response = await axios.get(this.promptUrl, { params });

            runInAction(() => {

                const arr = Array.from(response.data.data) as Prompt[];
                arr.forEach(p => {
                    var t = {} as Prompt;
                    t.id = p.id;
                    t.isAdmin = p.isAdmin;
                    t.isVisible = p.isVisible;
                    t.promptText = p.promptText;
                    this.prompts.push(t);
                });

            })

        } catch (error) {
            console.log(error);
        }
    }

    getAllInputs = async () => {
        try {
            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            axios.interceptors.response.use(async response => {

                const pag = response.headers['pagination'];

                this.setPagination(JSON.parse(pag!.toString()));

                return response;
            })
            const params = this.axiosParams;

            const response = await axios.get(this.inputUrl, { params });

            runInAction(() => {
                var data = response.data.data;


                data.map((item: any) => {

                    const inp = {
                        rawOutput: item.rawOutput,
                        rawInput: item.rawInput,
                        date: item.date,
                        totalTokens: item.totalTokens,
                        promptText: item.promptText,
                        id: item.id
                    } as AdminInput;

                    this.adminInputs.push(inp);
                });
            });



        } catch (error) {

            console.log(error);
        }
    }

    addNewAdminPrompt = async (prompt: NewPrompt) => {
        try {
            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            const response = await axios.post(this.addPromptUrl, prompt);

        } catch (error) {

        }
    }

    deleteAdminPrompt = async (id: number) => {
        try {
            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            const response = await axios.delete(this.deleteAdminPromptUrl + '/' + id);

        } catch (error) {

        }
    }


    deletePrompt = async (id: number) => {
        try {
            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            const response = await axios.delete(this.deletePromptUrl + '/' + id);

        } catch (error) {

        }
    }

    setPagination = (pagination: Pagination) => {
        this.pagination = pagination;
    }

}
